import type { BlockStateUnionType } from '@unifyapps/defs/types/block';
import { isRuntimeBlockId } from '../../../utils/runTimeBlocks';
export const getCombinedBlockState = ({
  blocksState = {},
  blocksRuntimeState,
}: {
  blocksState?: Record<string, BlockStateUnionType | undefined> & {
    runtimeBlocks?: Record<string, BlockStateUnionType | undefined>;
  };
  blocksRuntimeState?: Record<string, Record<string, unknown>>;
}) => {
  const runtimeStateBlockIds = Object.keys(blocksRuntimeState ?? {});

  if (blocksRuntimeState === undefined || runtimeStateBlockIds.length === 0) {
    return blocksState;
  }

  const updatedBlocksState = { ...blocksState };

  if (!updatedBlocksState.runtimeBlocks) {
    updatedBlocksState.runtimeBlocks = {};
  }

  for (const runtimeStateBlockId of runtimeStateBlockIds) {
    const blockRuntimeState = blocksRuntimeState[runtimeStateBlockId];
    const existingBlockState = blocksState[runtimeStateBlockId];

    const copyBlockState = existingBlockState ? { ...existingBlockState } : undefined;

    const newCopy = getCombinedEachBlockState({
      blockState: copyBlockState,
      blockRuntimeState,
    });

    updatedBlocksState[runtimeStateBlockId] = newCopy as BlockStateUnionType;

    if (isRuntimeBlockId(runtimeStateBlockId)) {
      updatedBlocksState.runtimeBlocks[runtimeStateBlockId] = newCopy as BlockStateUnionType;
    }
  }

  return updatedBlocksState;
};

// Function to combine each block's state with runtime data
const getCombinedEachBlockState = ({
  blockState,
  blockRuntimeState,
}: {
  blockState: BlockStateUnionType | undefined;
  blockRuntimeState: Record<string, unknown>;
}): Partial<BlockStateUnionType> => {
  // Create a copy of the blockState
  if (!blockState) {
    return {
      context: blockRuntimeState,
    };
  }

  // Initialize context if it does not exist
  if (!blockState.context) {
    blockState.context = {};
  }

  // Set the context to blocksRuntimeState
  blockState.context = blockRuntimeState;

  return blockState;
};
